<ng-container *ngIf="!ready"><div style="height:40px; text-align: center;background-color: #003366;line-height: 40px; font-size: 20px;color:#506d89">{{tickerText}}</div></ng-container>
<div class="ticker-wrapper" *ngIf="ready">
    <div id="ticker-container" style="overflow: hidden; white-space: nowrap; box-sizing: border-box;" 
   
    title="As of {{latestCommonDate|date:'M/d/yyyy':'UTC'}}">



        <!-- <div #tickerContent id="ticker-content">

            <span class="investment">
                <span class="p-2 name">Source: Morningstar</span>
                <span class="p-2 name">As of {{investments[0].subtitle.end}}</span>
            </span>

            <span *ngFor="let stock of investments" class="investment">
                <span class="p-2 name" [innerHTML]="stock.name|safe:'html'"></span>
                <span class="p-2">{{stock.endingValue}}</span>

                <span class="ps-2" [ngClass]="{'green':stock._points[0]==='+','red':stock._points[0]==='-'}">{{stock._points}}</span>             

                <svg width="40" height="50" viewBox="20 0 50 50" xmlns="http://www.w3.org/2000/svg">
                    <polygon *ngIf="stock._points[0]==='+'" points="25,10 50,10 50,35" style="fill:#0cb24a;" />
                    <polygon *ngIf="stock._points[0]==='-'" points="25,35 50,10 50,35" style="fill:red;" />
                </svg>


                <span class="ps-2" [ngClass]="{'green':stock._points[0]==='+','red':stock._points[0]==='-'}">{{stock._percent}}%</span>
                <svg width="40" height="50" viewBox="20 0 50 50" xmlns="http://www.w3.org/2000/svg">
                    <polygon *ngIf="stock._points[0]==='+'" points="25,10 50,10 50,35" style="fill:#0cb24a;" />
                    <polygon *ngIf="stock._points[0]==='-'" points="25,35 50,10 50,35" style="fill:red;" />
                </svg>

            </span>

            <span class="investment">
                <span class="p-2 name">Source: Morningstar</span>
                <span class="p-2 name">As of {{investments[0].subtitle.end}}</span>
            </span>

            <span *ngFor="let stock of investments" class="investment">
                <span class="p-2 name" [innerHTML]="stock.name|safe:'html'"></span>
                <span class="p-2">{{stock.endingValue}}</span>

                <span class="ps-2" [ngClass]="{'green':stock._points[0]==='+','red':stock._points[0]==='-'}">{{stock._points}}</span>            

                <svg width="40" height="50" viewBox="20 0 50 50" xmlns="http://www.w3.org/2000/svg">
                    <polygon *ngIf="stock._points[0]==='+'" points="25,10 50,10 50,35" style="fill:#0cb24a;" />
                    <polygon *ngIf="stock._points[0]==='-'" points="25,35 50,10 50,35" style="fill:red;" />
                </svg>


                <span class="ps-2" [ngClass]="{'green':stock._points[0]==='+','red':stock._points[0]==='-'}">{{stock._percent}}%</span>
                <svg width="40" height="50" viewBox="20 0 50 50" xmlns="http://www.w3.org/2000/svg">
                    <polygon *ngIf="stock._points[0]==='+'" points="25,10 50,10 50,35" style="fill:#0cb24a;" />
                    <polygon *ngIf="stock._points[0]==='-'" points="25,35 50,10 50,35" style="fill:red;" />
                </svg>

            </span>


        </div> -->


        <div #tickerContent id="ticker-content">      
            <div id="ticker1" class="tickerGroup" style="padding:5px 20px; line-height: 1.2em;display:inline-block;position:relative;top:-10px">
                Source: Morningstar<br>As of {{latestCommonDate|date:'M/d/yyyy':'UTC'}}
            </div>
            <div *ngFor="let stock of tickerGroups" class="tickerGroup">
                <span class="name" [innerHTML]="stock.name|safe:'html'"></span>
                <table>
                    <tr *ngFor="let stack of stock.stack; let inx = index">
                        <th [innerHTML]="stack.name|safe:'html'"></th>
                        <td class="text-end">{{stack.endingValue|number:'1.2-2'}}</td>
                        <td class="text-end">{{stack._points}}</td><td class="ps-1"><span class="triangle" [ngClass]="{'green':stack._points[0]==='+', 'red':stack._points[0]==='-'}"></span></td>
                        <td class="text-end">{{stack._percent}}%</td><td class="ps-1"><span class="triangle" [ngClass]="{'green':stack._points[0]==='+', 'red':stack._points[0]==='-'}"></span></td>
                        <th class="ps-2 text-end"><span *ngIf="inx==0">YTD:</span></th>                       
                        <td class="text-end">{{stack._ytdCalc}}%</td><td class="ps-1"><span class="triangle" [ngClass]="{'green':stack._ytdCalc[0]!=='-', 'red':stack._ytdCalc[0]==='-'}"></span></td>
                    </tr>
                </table>
            </div> 

            <!-- REPEAT FIRST PART FOR WRAPPING EFFECT -->
            <div id="ticker2" #ticker2 class="tickerGroup" style="padding:5px 20px; line-height: 1.2em;display:inline-block;position:relative;top:-10px;">
                Source: Morningstar<br>As of {{latestCommonDate|date:'M/d/yyyy':'UTC'}}
            </div>
            <div *ngFor="let stock of tickerGroups" class="tickerGroup" >
                <span class="name" [innerHTML]="stock.name|safe:'html'"></span>
                <table>
                    <tr *ngFor="let stack of stock.stack">
                        <th [innerHTML]="stack.name|safe:'html'"></th>
                        <td class="text-end">{{stack.endingValue|number:'1.2-2'}}</td>
                        <td class="text-end">{{stack._points}}</td><td class="ps-1"><span class="triangle" [ngClass]="{'green':stack._points[0]==='+', 'red':stack._points[0]==='-'}"></span></td>
                        <td class="text-end">{{stack._percent}}%</td><td class="ps-1"><span class="triangle" [ngClass]="{'green':stack._points[0]==='+', 'red':stack._points[0]==='-'}"></span></td>
                    </tr>
                </table>
            </div> 
        </div>

        <div class="disclosure-wrapper" [ngClass]="{'home':currentUrl==='/'}" data-bs-toggle="modal" data-bs-target="#tickerDisclosuresModal">Disclosures</div>
        <a *ngIf="currentUrl==='/'" class="petition-wrapper" [ngClass]="{'home':currentUrl==='/'}" routerLink="/petition">Petition</a>
      
    </div>

   

   

</div>
<div class="disclosure">Source: Morningstar. <span *ngIf="ready">Ticker Data as of {{latestCommonDate|date:'M/d/yyyy':'UTC'}}. </span>Not Live Data, presented here for illustration purposes only.  Click <span class="disclosuresSpanButton" data-bs-toggle="modal" data-bs-target="#tickerDisclosuresModal">Disclosures</span> button for important information and descriptions.</div>

<!-- Modal -->
<div class="modal" id="tickerDisclosuresModal" tabindex="-1" aria-labelledby="tickerDisclosuresModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="tickerDisclosuresModalLabel">Disclosure</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p>Source: Morningstar. <span *ngIf="ready">Ticker Data as of {{latestCommonDate|date:'M/d/yyyy':'UTC'}}.</span>
                    <p>
                        Price Return measures the performance of an index based solely on the price changes of its constituent stocks, ignoring any dividends or interest payments. Total Return measures the performance of an index by including both the price changes of its constituent stocks and the income generated from dividends or interest
                        payments reinvested into the index.
                    </p>
                    <p>You cannot make an investment directly into an index. There are no guarantees investment strategies will be successful. Past performance is no guarantee of future results. Investing involves risks, including possible loss of principal.</p>


                    <p>For sources and descriptions of indexes shown see:</p>
                    <ul>                    
                        <li>S&P 500:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/sp-500/#overview">https://www.spglobal.com/spdji/en/indices/equity/sp-500/#overview</a></li>                    
                        <li>Dow Jones Industrial Average®:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/dow-jones-industrial-average/#overview">https://www.spglobal.com/spdji/en/indices/equity/dow-jones-industrial-average/#overview</a></li>                       
                        <li>NASDAQ Composite:<br><a target="_blank" href="https://www.nasdaq.com/market-activity/index/comp">https://www.nasdaq.com/market-activity/index/comp</a></li>    
                        <li>Russell 2000®:<br><a target="_blank" href="https://www.lseg.com/en/ftse-russell/indices/russell-us">https://www.lseg.com/en/ftse-russell/indices/russell-us</a></li>                       
                        <li>FSE DAX:<br><a target="_blank" href="https://www.boerse-frankfurt.de/en">https://www.boerse-frankfurt.de/en</a></li>                        
                        <li>S&P/ASX 200:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/sp-asx-200/#overview">https://www.spglobal.com/spdji/en/indices/equity/sp-asx-200/#overview</a></li>                       
                        <li>S&P/TSX Composite:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/sp-tsx-composite-index/#overview">https://www.spglobal.com/spdji/en/indices/equity/sp-tsx-composite-index/#overview</a></li>
                        <li>FTSE MIB:<br><a target="_blank" href="https://www.lseg.com/en/ftse-russell/indices/mib-open-value">https://www.lseg.com/en/ftse-russell/indices/mib-open-value</a></li>                      
                        <li>BME IBEX 35:<br><a target="_blank" href="https://www.bolsasymercados.es/bme-exchange/en/Indices/Summary">https://www.bolsasymercados.es/bme-exchange/en/Indices/Summary</a></li>
                        <li>Euronext AEX:<br><a target="_blank" href="https://www.euronext.com/en/news/aex-index-0">https://www.euronext.com/en/news/aex-index-0</a></li>    
                        <li>FTSE 100:<br><a target="_blank" href="https://www.lseg.com/en/ftse-russell/indices/uk">https://www.lseg.com/en/ftse-russell/indices/uk</a></li>
                        <li>ISEQ Overall:<br><a target="_blank" href="https://live.euronext.com/en/product/indices/IE0001477250-XDUB">https://live.euronext.com/en/product/indices/IE0001477250-XDUB</a></li>
                        <li>Euronext Paris CAC 40:<br><a target="_blank" href="https://www.euronext.com/en/news/cac-40-index-0">https://www.euronext.com/en/news/cac-40-index-0</a></li>
                        


                        
                        
                </ul>

                <!-- <ul>                    
                    <li>S&P 500:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/sp-500/#overview">https://www.spglobal.com/spdji/en/indices/equity/sp-500/#overview</a></li>                    
                    <li>DOW<sup>®</sup>:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/dow-jones-industrial-average/#overview">https://www.spglobal.com/spdji/en/indices/equity/dow-jones-industrial-average/#overview</a></li>                       
                    <li>Germany DAX:<br><a target="_blank" href="https://www.boerse-frankfurt.de/en">https://www.boerse-frankfurt.de/en</a></li>                        
                    <li>Australia ASX 200:<br><a target="_blank" href="https://www.spglobal.com/spdji/en/indices/equity/sp-asx-200/#overview">https://www.spglobal.com/spdji/en/indices/equity/sp-asx-200/#overview</a></li>                       
                    <li>Italy MIB:<br><a target="_blank" href="https://www.lseg.com/en/ftse-russell/indices/mib-open-value">https://www.lseg.com/en/ftse-russell/indices/mib-open-value</a></li>                      
                    <li>Spain IBEX 35:<br><a target="_blank" href="https://www.bolsasymercados.es/bme-exchange/en/Indices/Summary">https://www.bolsasymercados.es/bme-exchange/en/Indices/Summary</a></li>
                    <li>Netherlands AEX:<br><a target="_blank" href="https://www.euronext.com/en/news/aex-index-0">https://www.euronext.com/en/news/aex-index-0</a></li>    
                    <li>UK FTSE 100:<br><a target="_blank" href="https://www.lseg.com/en/ftse-russell/indices/uk">https://www.lseg.com/en/ftse-russell/indices/uk</a></li>
                    <li>Ireland ISEQ:<br><a target="_blank" href="https://live.euronext.com/en/product/indices/IE0001477250-XDUB">https://live.euronext.com/en/product/indices/IE0001477250-XDUB</a></li>
                    <li>France CAC 40:<br><a target="_blank" href="https://www.euronext.com/en/news/cac-40-index-0">https://www.euronext.com/en/news/cac-40-index-0</a></li>
                </ul> -->


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

            </div>
        </div>
    </div>
</div>